module.exports = __webpack_public_path__ + "img/cambiodivisa-icon.18245ebd.png";